import { formatFromIsoToFrDate } from '@/utils/date'

export default {
  methods: {
    dateFormatter(date) {
      if (date !== null && date !== undefined) {
        return formatFromIsoToFrDate(date)
      }
    },
  },
}
